import React, { useEffect, useState, useRef } from 'react'
import { DataTable, Box, Grommet } from 'grommet'
import styled from 'styled-components'
import Banner from '../components/Banner'
import * as vars from '../variables.js'
import { ranking } from '../api'

const Layout = styled.div`
  font-family: 'IBM Plex Sans', sans-serif;
`

const Table = styled.div`
  margin-top: ${vars.bannerHeight}px;
  padding: 50px;
`

function useInterval(callback, delay) {
  const savedCallback = useRef()

  // Remember the latest callback.
  useEffect(() => {
    savedCallback.current = callback
  }, [callback])

  // Set up the interval.
  useEffect(() => {
    function tick() {
      savedCallback.current()
    }
    if (delay !== null) {
      let id = setInterval(tick, delay)
      return () => clearInterval(id)
    }
  }, [delay])
}

const LinkStyle = styled.div`
  a {
    color: ${vars.blue};
    cursor: pointer;
    text-decoration: none;
    transition: all 0.3s;
  }
  :hover {
    font-size: 1.05em;
    color: ${vars.lightBlue};
  }
`

const Link = ({ ticket }) => (
  <LinkStyle>
    <a href={`https://jira.illum.io/browse/${ticket}`} target="_blank" rel="noopener noreferrer" key={ticket}>
      {ticket}
    </a>
  </LinkStyle>
)

function Ranking() {
  const [ranks, setRanks] = useState([])
  const fetchRanks = () => {
    const getRanking = async () => await ranking()
    getRanking().then(data => setRanks(data))
  }

  useInterval(fetchRanks, 3000)
  useEffect(fetchRanks, [])

  return (
    <Box animation="fadeIn">
      <Layout>
        <Banner />
        <Table>
          <Grommet>
            <DataTable
              size="xlarge"
              border={true}
              sortable={true}
              columns={[
                {
                  align: 'center',
                  property: 'points',
                  header: 'Points',
                },
                {
                  align: 'center',
                  property: 'ticket',
                  header: 'Jira Ticket',
                  primary: true,
                  render: ({ ticket }) => <Link ticket={ticket} />,
                },
              ]}
              data={ranks.map(([ticket, points]) => {
                return {
                  ticket,
                  points,
                }
              })}
            />
          </Grommet>
        </Table>
      </Layout>
    </Box>
  )
}

export default Ranking
